import * as mobx from 'mobx';
import { ISubWindowParameters } from '../../../infrastructure/sub-windows';
import { ISubWindowViewModel, SubWindowViewModel } from './sub-window.viewmodel';
import { CommonSubWindow, CommonSubWindowMinimized } from './common/common-sub-window';
import { SubWindowFacade } from './subwindow-facade';

// eslint-disable-next-line no-unused-vars
interface ISubWindowInListDescriptor<T> {
    subWindowContextData: ISubWindowViewModel;
    uid: number;
}

class SubWindowsHostViewModel {
    @mobx.observable
    // disable no-any because sub-windows can be called with custom parameters types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private activeSubWindows: ISubWindowInListDescriptor<any>[];

    constructor() {
        this.activeSubWindows = [];
    }

    @mobx.action
    public showSubWindow = <T,>(parameters: ISubWindowParameters<T>) => {
        const newSubWindowInListDescriptor = {
            uid: (new Date()).getTime(),
            subWindowContextData: null,
        };

        const descriptorWithDefaults = {
            minimizedLayoutComponent: CommonSubWindowMinimized,
            layoutComponent: CommonSubWindow,
            ...parameters
        };

        newSubWindowInListDescriptor.subWindowContextData = new SubWindowViewModel(() => {
            this.handleCloseSubWindow(newSubWindowInListDescriptor);
        },
            () => null,
            () => null,
            descriptorWithDefaults);

        if (parameters.showAsFirst) {
            this.activeSubWindows.unshift(newSubWindowInListDescriptor);
        } else {
            this.activeSubWindows.push(newSubWindowInListDescriptor);
        }

        return new SubWindowFacade(
            newSubWindowInListDescriptor.subWindowContextData,
            newSubWindowInListDescriptor.uid,
        );
    };

    @mobx.action
    public deactivate() {
        this.activeSubWindows = [];
    }

    public getActiveSubWindows() {
        // disable no-any because sub-windows can be called with custom parameters types
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this.activeSubWindows as readonly ISubWindowInListDescriptor<any>[];
    }

    @mobx.action
    // disable no-any because sub-windows can be called with custom parameters types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private handleCloseSubWindow = (descriptor: ISubWindowInListDescriptor<any>) => {
        const descriptorIndex = this.findIndexByUid(descriptor.uid);

        if (descriptorIndex === -1) {
            return null;
        }

        this.activeSubWindows.splice(descriptorIndex, 1);
    };

    private findIndexByUid(uid: number) {
        return this.activeSubWindows.findIndex(x => x.uid === uid);
    }
}

export { SubWindowsHostViewModel };
